var Base = require('_js/base'),
  ko = require('knockout');

function CheckboxList(params) {
  if (!params.checkedCallback) {
    throw 'Need to provide a callback for when checkboxes are checked';
  }
  var self = this;
  this.emptyListEvent = params.emptyListEvent;
  this.updateListEvent = params.updateListEvent;
  this.clearFiltersEvent = params.clearFiltersEvent;
  this.options = ko.observableArray(params.options || []);
  this.title = ko.observable(params.title || 'select many');

  var checkedOptions = [];

  if (params.category()) {
    checkedOptions = params.category().split(',');

    if (
      checkedOptions.length &&
      checkedOptions.length === this.options().length
    ) {
      checkedOptions = [];
    }
  }

  this.checkedOptions = ko.observableArray(checkedOptions);
  this.checkedOptions.subscribe(function() {
    params.checkedCallback(this.findOptions());
    this.updateList();
  }, this);

  if (this.clearFiltersEvent) {
    ko.postbox.subscribe(this.clearFiltersEvent, function() {
      self.clearOptions();
    });
  }

  params.checkedCallback(this.findOptions());
  this.updateList();
}

CheckboxList.prototype = new Base();

CheckboxList.prototype.init = function(element) {
  this.$element = $(element);
};

CheckboxList.prototype.updateList = function() {
  if (this.updateListEvent) {
    ko.postbox.publish(this.updateListEvent, this.findOptions());
  }
};

CheckboxList.prototype.findOptions = function() {
  var self = this;

  var newOptions = $.map(this.options(), function(option) {
    return $.map(self.checkedOptions(), function(chkOption) {
      if (option.Key === parseInt(chkOption)) {
        return option.Key;
      }
    });
  });

  if (newOptions.length > 0) {
    return newOptions;
  }

  var allOptions = $.map(this.options(), function(option) {
    return option.Key;
  });

  return allOptions;
};

CheckboxList.prototype.clearOptions = function() {
  this.checkedOptions([]);
  if (this.emptyListEvent) {
    ko.postbox.publish(this.emptyListEvent);
  }
};

module.exports = CheckboxList;
